import * as React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  getFilters,
  toggleFilterOption,
  updateFilterQuery,
} from '../data/jobs/jobActions';
import {
  selectOrderedFilters,
} from '../data/jobs/jobSelectors';
import {
  createDidError,
  createIsLoading,
  createRequestSelector,
} from '../data/requests/requestsSelectors';
import { CheckboxField, TextInput } from './static/Inputs';
import { Error, Loading } from './static/Indicators';
import Header from './static/Header';
import Icon from './static/Icons';

import createLogger from '../utils/createLogger';

const DEBUG = false;
const debug = createLogger(DEBUG, `Filters.js`);

class Filters extends React.Component {

  static role = `filters`;

  static dependencies = [
    `GET_JOB_FILTERS`,
  ];

  static propTypes = {
    filters: PropTypes.array,
    toggleFilterOption: PropTypes.func.isRequired,
    updateFilterQuery: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    didError: PropTypes.bool.isRequired,
    wasSent: PropTypes.bool.isRequired,
  };

  /* ------------ lifecycle methods ------------ */
  constructor(props) {
    super(props);
    debug.enter(`constructor`);
  }

  /* ------------ render methods ------------ */
  render() {
    const {
      filters,
      didError,
      isLoading,
      toggleFilterOption,
      updateFilterQuery,
    } = this.props;

    debug.enter(`render`);
    debug.log(`  filters:`, filters);


    if (isLoading) {
      return (
        <aside className="filters">
          <h3>Filters</h3>
          <Loading/>
        </aside>
      )
    }

    if (didError || !filters) {
      return (
        <aside className="filters">
          <h3>Filters</h3>
          <Error message="Could not retrieve filters"/>
        </aside>
      )
    }

    const methods = {
      toggle: toggleFilterOption,
      search: updateFilterQuery,
    };

    return (
      <aside className="filters">
        <Header title="Filters"/>
        { filters.map((category) => <FilterCategory key={category.id}
                                                    {...category}
                                                    {...methods}/>) }
      </aside>
    );
  }
}


class FilterCategory extends React.Component {

  static propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    options: PropTypes.array.isRequired,
    canQuery: PropTypes.bool.isRequired,
    query: PropTypes.string,
    toggle: PropTypes.func,
    search: PropTypes.func,
  };

  /* ------------ lifecycle methods ------------ */
  constructor(props) {
    super(props);

    this.state = {
      search_input: ``,
    }
  }

  /* ------------ event handlers ------------ */
  onSearch = (input) => {
    const { id, search } = this.props;

    search(id, input);
  };

  onToggle = (option) => () => {
    const { id, toggle } = this.props;
    debug.enter(`onToggleFilter`);
    debug.log(`  option:`, option);

    toggle(id, option);
    this.setState({ search_input: `` });
  };

  /* ------------ render methods ------------ */
  renderFilterOption = (option) => {
    const { onToggle } = this;
    const { id } = this.props;

    let nodeID = `filters-${id}-${option.id}`;
    const config = {
      key: nodeID,
      name: nodeID,
      label: option.label,
      checked: option.active,
      onChange: onToggle(option.id),
    };

    return <CheckboxField {...config}/>
  };

  render() {
    const { onSearch,
      renderFilterOption,
    } = this;
    const {
      id, query,
      canQuery,
      options,
      label,
    } = this.props;

    debug.enter(`render (FilterCategory)`);
    debug.log(`  id: ${id}`);
    debug.log(`  label: ${label}`);
    debug.log(`  options:`, options);
    debug.log(`  canQuery: ${canQuery}`);
    debug.log(`  query: ${query}`);

    if (canQuery) {
      const searchConfig = {
        type: `search`,
        name: `filters-${id}-search`,
        placeholder: `Search cities...`, // TODO: make generic
        onSubmit: onSearch,
      };

      return (
        <section>
          <Header title={label}/>

          <TextInput {...searchConfig}>
            <Icon.Search/>
          </TextInput>

          { options.map(renderFilterOption) }
        </section>
      );
    }

    return (
      <section>
        <Header title={label} tier={4}/>
        { options.map(renderFilterOption) }
      </section>
    );
  }

}



/* ------------ redux connect ------------ */
const mapStateToProps = (state) => {
  const selectRequest = createRequestSelector(Filters.dependencies);
  const selectLoading = createIsLoading(Filters.dependencies);
  const selectError = createDidError(Filters.dependencies);

  return {
    wasSent: !!selectRequest(state),
    isLoading: selectLoading(state),
    didError: selectError(state),
    filters: selectOrderedFilters(state),
  }
};

export default connect(mapStateToProps, {
  toggleFilterOption,
  updateFilterQuery,
  getFilters,
})(Filters);




// WEBPACK FOOTER //
// ./src/components/Filters.js